<template>
    <div class="echart-chart-block">
        <div class="chart-info" :style="sensorStyle">
            <div class="chart-title">
                <i :class="$tools.style.classSensorIcon(sensorCodeList[0], 'block-title')"></i>{{ $t('sensor.' + sensorCodeList[0]) }} & {{ $t('sensor.' + sensorCodeList[1]) }}
            </div>
            
            <div v-if="info_type == 'realtime'" class="latest-value">
            
                <div>
                    
                    <template v-if="lastSpeed != undefined">
                        <div class="latest-value-number">{{ lastSpeed }}</div>
                        <div class="latest-value-unit" v-html="$t('sensor.u_' + sensorCodeList[0])"></div>
                    </template>

                    <div v-if="lastDirection" class="latest-value-wind">
                        <div class="wind-direction-icon">
                            <i :class="'wi wi-wind wi-from-' + lastDirection.toLowerCase()"></i>
                        </div>
                        {{ $t('wind.' + lastDirection) }}
                    </div>

                    <template v-if="lastSpeed != undefined">
                        <div v-if="lastSpeed <= 5.5" class="latest-value-wind">{{ $t('chart.wind_light') }}</div>
                        <div v-else-if="lastSpeed <= 10.7" class="latest-value-wind">{{ $t('chart.wind_moderate') }}</div>
                        <div v-else class="latest-value-wind">{{ $t('chart.wind_strong') }}</div>
                    </template>

                </div>
           
            </div>
        </div>
        <div :id="chartID" class="chart"></div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import echarts from 'echarts'
import ecTools from '@/echarts/echarts-tools'

export default {
    props:
    {
        chartID: {
            type: String,
            required: true,
        },
        info_type: {
            type: String,
            default: 'realtime',
        },
        dataList: { type: Object },
        time: {
            type: Array,
            default: function () { return [] }
        },
        standard: {
            type: Object,
            default: undefined,
        },
        compareList: {
            type: Array,
            default: function () { return [] }
        },
        deviceInfo: {
            type: Object,
            default: undefined,
        },
        showToolbox: {
            type: Boolean,
            default: true,
        },
        xAxisName: { type: String, },
        yAxisName: { type: String, },
        xAxisFormat: {
            type: String,
            default: 'MM/DD HH:mm',
        },
    },
    data () {
        return {
            theChart: undefined,
            sensorCodeList: ['wind_speed','wind_direction'],
            lastSpeed: undefined,
            lastDirection: undefined,
        }
    },
    mounted () {
        this.theChart = echarts.init(document.getElementById( this.chartID ));
        this.drawChartPrepare();
    },
    computed: {
        ...mapState({
            'language': state => state.user.language,
            'screenWidth': state => state.system.screenWidth,
            'contentWidth': state => state.system.contentWidth,
        }),

        sensorStyle ()
        {
            let _setting = ecTools.getSensorSettings( this.sensorCodeList[0] )

            return {
                color: ecTools.chart_HeatMap_Color[ _setting.color ][2]
            }
        },
    },
    watch: {
        // 偵測到 [ 語言 ] 變動就更新圖表
        language ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 時間 ] 變動就更新圖表
        time ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 標準 ] 變動就更新圖表
        standard ()
        {
            this.drawChartPrepare();
        },

        // 偵測到 [ 視窗寬度 ] 變動就更新圖表
        screenWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
        // 偵測到 [ 版面寬度 ] 變動就更新圖表
        contentWidth (val, oldVal)
        {
            if ( val != oldVal && this.theChart != undefined )
            {
                this.theChart.resize()
            }
        },
    },
    methods: {

        __computeWindData (dataList, code_WindSpeed, code_WindDirection)
        {
            let _newData = [];
            let _days = dataList.time;
            //let days = ecTools.get_XAxis_day( dataList.time.length, dataList.time );
            // console.log( 'days' )
            // console.log( _days )
            // console.log( days.length )
            // console.log( dataList.wind_speed )

            let _directions = ecTools.computeWindDirection( dataList[ code_WindDirection ] )
            
            for (let i=0; i<_days.length; i++)
            {
                _newData.push( [ _days[i], dataList[ code_WindSpeed ][i], _directions[i] ] );
            }
            this.lastSpeed = _newData[ _days.length-1 ][1]
            this.lastDirection = _newData[ _days.length-1 ][2]
            // console.log( _newData )

            return _newData;
        },

        drawChartPrepare ()
        {
            if (this.dataList && this.dataList.wind_speed && this.dataList.wind_speed.length > 0)
            {
                let _setting = ecTools.getSensorSettings( this.sensorCodeList[0] )

                this.drawChart( this.theChart,
                                this.sensorCodeList,
                                this.dataList,
                                this.time,
                                this.standard,
                                _setting,
                                this.deviceInfo,
                                this.showToolbox,
                                [ this.xAxisName, this.yAxisName ] );
            }
        },

        drawChart ( chart,
                    _sensorCodeList,
                    _dataList,
                    _time,
                    _standard,
                    _sensorSetting,
                    _deviceInfo = undefined,
                    _showToolbox,
                    _axisName )
        {
            let _deviceName = '';
            let _unit = this.$t('sensor.u_' + _sensorCodeList[0]);
            let _legendTitle = [];
            let _color = ecTools.getColorList( _sensorSetting.color );
            let _colorRGBA = ecTools.getColor_RGB( _color[1] );
            let _precision = _sensorSetting.precision;
            let bounding = ( _sensorSetting.bounding != undefined ? _sensorSetting.bounding.slice() : [ 0, 5 ] );
            let bounding_limit = ( _sensorSetting.bounding_limit != undefined ? _sensorSetting.bounding_limit : [ undefined, undefined ] );

            let _info = {
                dataTitle: [ this.$t('sensor.' + _sensorCodeList[0]), this.$t('sensor.' + _sensorCodeList[1]) ],
                color: {
                    'wind_strong':   _color[2],//'#18BF12',
                    'wind_moderate': _color[1],//'#f4e9a3',
                    'wind_light':    _color[0],//'#D33C3E',
                    'wind_area':     '0, 102, 75',
                },
                xAxis_name: ( _axisName[0] ? this.$t('u.'+_axisName[0]) : ''),
                yAxis_name: ( _axisName[1] ? this.$t('u.'+_axisName[1]) : _unit ),
                direction: ecTools.theDirection,
            };

            let _directionMap = ecTools.getDirectionMap();
            let _data_list_speed = _dataList[ _sensorCodeList[0] ]
            for (let i=0; i<_data_list_speed.length; i++)
            {
                // 先檢查如果有異常數值，就設為最大/最小可顯示的數值
                _data_list_speed[i] = ecTools.checkDataInBoundingLimit( _data_list_speed[i], bounding_limit ).data;
            }
            _dataList[ _sensorCodeList[0] ] = _data_list_speed;

            let _data_wind = this.__computeWindData( _dataList, _sensorCodeList[0], _sensorCodeList[1] );
            
            for (let i=0; i<_data_wind.length; i++)
            {
                _data_wind[i][1] = ecTools.checkDataBounding( _data_wind[i][1], bounding, bounding_limit, _precision, false );
            }
            
            let tips_label =
            [
                this.$t('chart.wind_strong') + ' >= 10.8 m/s',
                this.$t('chart.wind_moderate') + ' 5.5 ~ 10.7 m/s',
                this.$t('chart.wind_light') + ' < 5.5 m/s'
            ];
            let tips_left = 'center';



            


            // option functions

            let dims = {
                time: 0,
                windSpeed: 1,
                R: 2
            };
            let arrowSize = 18;
            function __renderWindArrow(param, api) {
                //console.log( _data[ param.dataIndex ].R );
                let point = api.coord([
                    api.value(dims.time),
                    api.value(dims.windSpeed)
                ]);
            
                return {
                    type: 'path',
                    shape: {
                        pathData: 'M31 16l-15-15v9h-26v12h26v9z',
                        x: -arrowSize / 2,
                        y: -arrowSize / 2,
                        width: arrowSize,
                        height: arrowSize
                    },
                    rotation: _directionMap[api.value(dims.R)],
                    position: point,
                    style: api.style({
                        stroke: '#555',
                        lineWidth: 1
                    })
                };
            }




            // 設定 [ 風速 ] 圖表
            let _series = []
            _series.push(
                {
                    type: 'line',
                    yAxisIndex: 1,
                    showSymbol: false,
                    hoverAnimation: false,
                    symbolSize: 10,
                    areaStyle: {
                        color: {
                            type: 'linear',
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                { offset: 0, color: 'rgba(' + _info.color.wind_area + ',1)' },
                                { offset: 0.5, color: 'rgba(' + _info.color.wind_area + ',0.7)' },
                                { offset: 1, color: 'rgba(' + _info.color.wind_area + ',0)' }
                            ]
                        }
                    },
                    lineStyle: { color: 'rgba(' + _info.color.wind_area + ',1)' },
                    itemStyle: { color: 'rgba(' + _info.color.wind_area + ',1)' },
                    encode: { x: dims.time, y: dims.windSpeed },
                    data: _data_wind,
                    z: 2,
                    markLine: {
                        data: _markLine,
                    },
                    markArea: {
                        data: _markArea,
                    },
                }
            );
            // 設定 [ 風向 ] 圖表
            if ( _dataList[ _sensorCodeList[1] ] && _dataList[ _sensorCodeList[1] ].length > 0 )
            {
                _series.push(
                    {
                        type: 'custom',
                        renderItem: __renderWindArrow,
                        encode: { x: dims.time, y: dims.windSpeed },
                        data: _data_wind,
                        z: 10
                    }
                );
            }



            let _markLine = []
            let _markArea = []
            // 標準/警示線 or 標準/警示區域
            if (_standard != undefined)
            {
                if (_standard.warning_line != undefined)
                {
                    ecTools.createMarkLine( _standard.warning_line, _markLine, bounding );
                }
                if (_standard.warning_area != undefined)
                {
                    ecTools.createMarkArea( _standard.warning_area, _markArea, bounding, _data.length );
                }
            }

            // console.log( _dataList.time );
            // console.log( _dataList.wind_speed );
            // console.log( _data_wind );
            let thisChartTool = this;
            
            // 檢查視窗大小，顯示/隱藏項目
            let _chartWidth = chart.getWidth();

            let option = {
                toolbox: ecTools.createToolbox( this.chartID, _deviceName + ' ' + _info.dataTitle[0] + ' & ' +  _info.dataTitle[1] + ' - Wind Chart', _showToolbox ),
                tooltip:
                {
                    trigger: 'axis',
                    formatter: function (params) {
                        //console.log(params[0]);
                        let _showDate = params[0].value[dims.time];
                        let _showSpeed = '<i class="fa fa-circle" style="color:'+ params[0].color +';"></i> ' + _info.dataTitle[0] + ': '
                                       + params[0].value[dims.windSpeed] + ' ' + _info.yAxis_name;

                        let _showDirection = '<i class="fa fa-circle" style="color:'
                                           + params[0].color +';"></i> ' + _info.dataTitle[1] + ': '
                                           + thisChartTool.$t('wind.' + params[0].value[dims.R] );

                        let _tooltip = _showDate;
                        _tooltip += '<div class="chart-tooltip">';
                        _tooltip += _showSpeed + '<br>';
                        _tooltip += _showDirection + '</div>';

                        return _tooltip;
                    }
                },
                grid:
                {
                    x: 35,//'5%',
                    //y: -30,
                    top: '45',
                    bottom: '30%',
                    width: ( _chartWidth < 300 ? '75%' : '90%' ),
                },
                xAxis:
                {
                    type: 'time',
                    name: _info.xAxis_name,//'時間',
                    nameLocation: 'middle',
                    nameGap: 34,
                    axisLabel: { margin: 10 },
                    maxInterval: 3600 * 1000 * 24,
                },
                yAxis: [
                    {
                        name: _info.dataTitle[0] + ' ' + _info.yAxis_name,//'風速（m/s）',
                        nameLocation: 'middle',//'top',
                        nameGap: 20,
                        min: ( bounding[0] ),
                        max: ( bounding[1] ),
                        splitLine: {
                            show: true,
                            lineStyle: {
                                color: 'rgba(' + _colorRGBA[0] + ',' + _colorRGBA[1] + ',' + _colorRGBA[2] + ',0.35)',
                            }
                        },
                    },
                    {
                        axisLine:  {show: false},
                        axisTick:  {show: false},
                        axisLabel: {show: false},
                        splitLine: {show: false},
                        min: ( bounding[0] ),
                        max: ( bounding[1] ),
                    }
                ],
                visualMap: {
                    type: 'piecewise',
                    // show: false,
                    orient: 'horizontal',
                    top: 7,
                    left: tips_left,
                    //textStyle: { color: 'white' },
                    pieces: [{
                        gte: 10.8,
                        color: '#ff6666',
                        label: tips_label[0]//'強風'
                    }, {
                        gte: 5.5,
                        lt: 10.8,
                        color: '#4db8ff',
                        label: tips_label[1]//'中度'
                    }, {
                        lt: 5.5,
                        color: 'rgba(204, 255, 102, 0.8)',
                        label: tips_label[2]//'微風'
                    }],
                    outOfRange: { color: '#999' },
                    seriesIndex: 1,
                    dimension: 1
                },
                dataZoom: [{
                    type: 'inside',
                    xAxisIndex: 0,
                    minSpan: 5
                }, {
                    type: 'slider',
                    xAxisIndex: 0,
                    minSpan: 5,
                    height: 18,
                    bottom: 2,
                    handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
                    handleSize: '120%'
                }],
                series: _series
            };

            chart.setOption(option);
        },
        
    }
    
}
</script>

<style lang="scss" scoped>



</style>
